import { useState } from 'react';
import { ConfirmDialog } from '../../../components/ConfirmDialog';
import { UserService } from '../../configuracoes/usuario/Service';
import { useAppContext } from '../../../contexts/AppContext';
import { useEstabsContext } from '../../../contexts/EstabsContext';

const userService = new UserService();

export const ToggleAddEstabUserBtn = ({
    estabId,
    estabName,
    onDone,
}: {
    estabId: string;
    estabName?: string;
    onDone?: () => void;
}) => {
    const { errorSnackbar, successSnackbar } = useAppContext();
    const { estabsUser, reloadEstab } = useEstabsContext();
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const linked = estabsUser.some((e) => e._id === estabId && e.type === 'client');

    const handleConfirm = async () => {
        try {
            setLoading(true);

            if (linked) {
                await userService.removeUserClientEstab(estabId);
                successSnackbar('Estabelecimento removido da sua conta.');
            } else {
                await userService.addUserClientEstab(estabId);
                successSnackbar('Estabelecimento adicionado à sua conta.');
            }

            setOpen(false);
            reloadEstab();
            onDone?.();
        } catch (err) {
            console.log(err);
            errorSnackbar(`Não foi possível ${linked ? 'remover' : 'adicionar'} o estabelecimento.`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {linked ? (
                <button type="button" className="sf-destructive-row" onClick={() => setOpen(true)}>
                    Remover da minha conta
                </button>
            ) : (
                <button type="button" className="btn btn-primary w-full" onClick={() => setOpen(true)}>
                    Adicionar à minha conta
                </button>
            )}

            {open && (
                <ConfirmDialog
                    title={linked ? 'Remover estabelecimento?' : 'Adicionar estabelecimento?'}
                    confirmLabel={linked ? 'Remover' : 'Adicionar'}
                    destructive={linked}
                    loading={loading}
                    onConfirm={handleConfirm}
                    onClose={() => setOpen(false)}
                >
                    {linked
                        ? `${estabName || 'O estabelecimento'} sai da sua conta, e você deixa de poder agendar por aqui até adicioná-lo de novo.`
                        : `${estabName || 'O estabelecimento'} entra na sua conta, e você poderá agendar horários e contratar planos.`}
                </ConfirmDialog>
            )}
        </>
    );
};
